/**
 * Shared constants for the Live Activity map, ported 1:1 from the mobile app so
 * pin colors, priority and the pulse animation match exactly.
 */

/**
 * Pin slot colors, indexed by stat priority. Matches mobile `miniPinColors`.
 * [0] check-ins, [1] events/RSVP, [2] breadcrumbs, [3] recent check-ins, [4] recent views,
 * [5] stickers.
 */
export const PIN_COLORS = [
  '#AA0100', // check-ins (red)
  '#2270DD', // events / RSVP (blue)
  '#E5A200', // breadcrumbs (amber)
  '#7A42F4', // recent check-ins (purple)
  '#8C8C8C', // recent views (grey)
  '#9747FF', // stickers (purple)
] as const

/** Highest-priority first; matches mobile `miniPinDisplayPriority`. */
export const PIN_DISPLAY_PRIORITY = [0, 1, 2, 3, 4, 5] as const

/** Number badge switches from circle to pill at this count (mobile threshold). */
export const BADGE_PILL_THRESHOLD = 10

// --- Pulse / ripple animation (mobile checked_in_venue_map_circles.dart) ---

export const PULSE_CHECKIN_COLOR = '#AA0100' // red
export const PULSE_RSVP_COLOR = '#1A74DF' // blue (note: slightly different from pin blue)

export const PULSE_WAVE_COUNT = 3
export const PULSE_CYCLE_MS = 3000

/**
 * Admin has no concept of the current user's "own" checked-in venue (mobile uses
 * intensity 1.0 for own venue, 0.38 for others). We render all live venues at a
 * single configurable intensity. Tune here.
 */
export const PULSE_INTENSITY = 0.6

// Real-google.maps.Circle radius math (only used if rendering geo-accurate
// pulses instead of the CSS ripple). Kept here for parity / future use.
export const PULSE_REFERENCE_ZOOM = 16
export const PULSE_REFERENCE_RADIUS_METERS = 55
export const PULSE_MAX_RADIUS_FACTOR = 1.75

/** baseRadiusMeters = 55 * 2^(16 - zoom) / clamp(cos(lat), 0.55, 1.0). */
export function pulseBaseRadiusMeters(mapZoom: number, latitude: number): number {
  const zoomFactor = Math.pow(2, PULSE_REFERENCE_ZOOM - mapZoom)
  const latRad = (latitude * Math.PI) / 180
  const latFactor = Math.min(1.0, Math.max(0.55, Math.cos(latRad)))
  return (PULSE_REFERENCE_RADIUS_METERS * zoomFactor) / latFactor
}
